import React from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function RegistrationFirstName(props: {
	labelClassName?: string;
	disabled?: boolean;
}) {
	const { t } = useTranslation("registration");
	const { labelClassName, disabled } = props;

	const { getValues, trigger, clearErrors } = useFormContext();

	return (
		<FormInputField
			id="firstName"
			className="form__field"
			name="firstName"
			label={t("FIRST_NAME_LABEL")}
			labelClassName={labelClassName}
			placeholder={t("FIRST_NAME_PLACEHOLDER")}
			pattern={{
				value: nameValidationPattern,
				message: t("INVALID_FIRST_NAME"),
			}}
			disabled={disabled}
			validate={{
				passValidate: () => {
					if (getValues("password")) {
						trigger("password");
					} else {
						clearErrors("password");
					}
				},
			}}
			required
		/>
	);
}
